<app-section [formConfig]="formConfig"
             [sectionRef]="section"
             [formGroup]="formGroup"
             [title]="title"
             [key]="key"
             [containerClass]="false">

    <ng-template #section>

        <div class="offers-section">
            <div class="offers-section__controls-row">
                <div class="offers-section__header">
                    <div *ngIf="showFilters" class="offers-filters__header filters-column"
                         [ngClass]="{'offers-filters__header--clickable': !filtersExpanded }"
                         (click)="offersFiltersHeaderClick()"
                    >
                        <span>{{ 'OFFER_SECTION.FILTERS_COMPONENT.header' | translate }}</span>
                        <span class="material-icons offers-filters__header__tune-icon"> tune </span>
                        <button class="offers-filters__header__button" (click)="changeFiltersVisibility($event)">
                            <i class="material-icons icon"> {{ buttonIcon }} </i>
                        </button>
                    </div>

                    <div class="sort-offer-container">
                        <div *ngIf="filtersService.filtersVisible" class="offers-filters__mobile-filters-button-wrapper">
                            <button class="offers-filters__mobile-filters-button" (click)="openMobileFilters()">
                                <span>{{ 'OFFER_SECTION.FILTERS_COMPONENT.buttonText' | translate }}</span>
                                <span class="material-icons"> tune </span>
                            </button>
                        </div>

                        <div class="number-offer">
                            <span *ngIf="offers.length > 0"> {{'OFFER_SECTION.haveFound' | translate}} </span>
                            <span *ngIf="offersNumber > 0" class="bold">
                                <span>{{ offersNumber }}</span>
                                {{ offersNumber | amountNounTranslation:translationsContainer:true | async }}
                            </span>
                            <span *ngIf="noOffersForFilters">{{ 'OFFER_SECTION.noOffersForFilters' | translate }}</span>
                        </div>
                        <div class="sort-offer" *ngIf="sortOffersVisible">
                            {{'OFFER_SECTION.sort' | translate}}:
                            <app-select
                                    (click)="onSortSelectClick()"
                                    [errorsMap]="sortFormFactoryService.errorsMap"
                                    [translateLabel]="true"
                                    [control]="sortFormGroup.controls['sort']"
                                    [fieldConfig]="sortFormFactoryService.fieldConfig('sort', sortFormConfig)"
                                    [context]="sortFormConfig.formKey">
                            </app-select>
                        </div>
                    </div>
                </div>
            </div>

            <div class="offers-section__main">
                <app-offers-filters *ngIf="showFilters"
                                    [ngClass]="{'display-none': !filtersExpanded}"></app-offers-filters>

                <div class="offers-section__offers">

                    <app-pzu-banner *ngIf="pzuBannerVisible"></app-pzu-banner>

                    <app-no-filtered-offers *ngIf="noOffersForFilters"></app-no-filtered-offers>

                    <div *ngFor="let tile of tiles">
                        <div *ngIf="tile.type === 'OFFER' else readonlyBox">
                            <app-offer [id]="tile.item.id"
                                       [item]="tile.item"
                                       [amountOfSelectedOffers]="selectedOffers.length"
                                       [checkOfferAvailable]="checkOfferAvailable"
                                       [checked]="offerChecked(tile.item)"
                                       (onCheckOffer)="checkOffer(tile.item)"
                                       (onUncheckOffer)="uncheckOffer(tile.item)"
                                       (onSelectOffer)="selectOffer(tile.item)"
                                       (onCompareOffers)="compareOffers()">
                            </app-offer>

                            <app-driver-sos-banner *ngIf="shouldShowBanner(tile.item.id)">
                            </app-driver-sos-banner>
                        </div>
                        <ng-template #readonlyBox>
                            <app-missing-data-offer *ngIf="tile.item.logos && tile.item.logos.length > 0"
                                                    [type]="tile.item.type"
                                                    [logos]="tile.item.logos"
                                                    [faded]="noOffersForFilters">
                            </app-missing-data-offer>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>

    </ng-template>

</app-section>
